import { Action } from '../actions';
import { Reducer } from 'redux';
import { ActionType } from '../actions/feature';
import { FeaturesState } from '../state/features';

const featureReducer: Reducer<FeaturesState, Action> = (state = { isLoading: true, all: {} }, action) => {
  switch (action.type) {
    case ActionType.TOGGLE_FEATURE:
      return {
        ...state,
        all: {
          ...state.all,
          [action.data]: !state.all[action.data],
        },
      };

    case ActionType.GET_FEATURE_FLAGS_SUCCESS:
      return {
        all: {
          ...state.all,
          ...action.data,
        },
        isLoading: false,
      };

    default:
      return state;
  }
};

export default featureReducer;
